import { render, staticRenderFns } from "./SelectBankExt.vue?vue&type=template&id=66f52de5&lang=pug"
import script from "./SelectBankExt.vue?vue&type=script&lang=js"
export * from "./SelectBankExt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports